import { render } from "./createReserveComponent.vue?vue&type=template&id=a506d2e4&scoped=true"
import script from "./createReserveComponent.vue?vue&type=script&lang=js"
export * from "./createReserveComponent.vue?vue&type=script&lang=js"

import "./createReserveComponent.vue?vue&type=style&index=0&id=a506d2e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a506d2e4"]])

export default __exports__